import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import vuetify from '@/plugins/vuetify'; // path to vuetify export
import router from '@/plugins/router';
import io from 'socket.io-client';
import VueHotkey from 'v-hotkey';
import VueCookies from 'vue-cookies';
import './registerServiceWorker';
import store from "@/store";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'

import NetworkPlugin from './network';
import stallWatchdog from './services/stallWatchdog';
import CONSTANTS from "@/constants";

import eventBus from '@/eventBus';
import dbmanager from './dbmanager';

var releaseStage = "development";

switch (process.env.VUE_APP_APPLICATION_ENV_BS)
{
    case 'properit_production':
        releaseStage = "production";
        break;
    case 'properit_teszt':
        releaseStage = "staging";
        break;
    default:
        releaseStage = "development";
        break;
}

if (document.location.href.includes("teszt"))
{
    releaseStage = "staging";
} else if (document.location.href.includes("dev") || document.location.href.includes("localhost"))
{
    releaseStage = "development";
} else {
    releaseStage = "production";
}



if (!document.location.href.includes("localhost")) {
    Bugsnag.start({
        apiKey: '6df7c8c41e70eaf88b86ab483d44de3f',
        plugins: [new BugsnagPluginVue()],
        appVersion: process.env.VUE_APP_VERSION,
        releaseStage: releaseStage,
        // JAVÍTÁS (74. tétel): a Bugsnag böngészős kliense alapból
        // OLDALBETÖLTÉSENKÉNT legfeljebb 10 eseményt küld, utána mindent
        // csendben eldob. A tájékoztató jelzések ("Report screen
        // connected/discconnected", "TimeSync disconnect", "Network change",
        // "logged in") is ebből fogynak - egy hosszú, szakadozó meccsen a keret
        // elfogyhat, és egy későbbi VALÓDI hiba már nem jut el hozzánk. Ezeket a
        // jelzéseket szándékosan megtartjuk: a 32021440528-as incidensnél ezekből
        // (és a hozzájuk csatolt breadcrumbokból) derült ki a gép verziója, a
        // fülek száma és a vihar vége. A Bugsnag felső határa 100.
        maxEvents: 50
    })
    BugsnagPerformance.start({
        apiKey: '6df7c8c41e70eaf88b86ab483d44de3f',
        appVersion: process.env.VUE_APP_VERSION,
        releaseStage: releaseStage
    })

    const bugsnagVue = Bugsnag.getPlugin('vue')
    bugsnagVue.installVueErrorHandler(Vue)
}

// JAVÍTÁS (77. tétel): fő szál fagyásfigyelő (l. src/services/stallWatchdog.js).
// Localhoston is fut (ott csak a konzolra ír, mert a Bugsnag nincs elindítva).
stallWatchdog.start();

router.afterEach((to, from) => {
    if (!document.location.href.includes("localhost")) {
        Bugsnag.leaveBreadcrumb('Navigated', {
            from: from.fullPath,
            to: to.fullPath,
            type: 'navigation'
        })
    }
})

var debug = require('debug')('MKSZ:main');

window.enabledebug = function (...args) {
    if (args.length) {
        args = args.map(el => 'MKSZ:' + el);
        localStorage.debug = args.toString();
    } else {
        localStorage.debug = 'MKSZ:*';
    }
    location.reload();
};

window.disabledebug = function () {
    localStorage.debug = '';
    location.reload();
};

if(process.env.VUE_APP_APPLICATION_ENV && process.env.VUE_APP_APPLICATION_ENV !== 'development') {
    window.config = require('./config/config_' + process.env.VUE_APP_APPLICATION_ENV);
}
else {
    window.config = require('./config/config');
}

window.version = require('./version');
window.CONSTANTS = require('./constants');
window.timesync = require('timesync');

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

const SOCKET_OPTS = {
    //transports: ['websocket'],            // kerüld a pollingot
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 100,
    reconnectionDelayMax: 8000,
    timeout: 20000,                       // CONNECT timeout (nem a ping/pong)
    withCredentials: false,                // ha szerveren CORS credentials true
    // path: '/socket.io/',               // ha Nginx/Ingress miatt eltér a path, itt egyezzen
    // forceNew: true,                    // ha izolálni akarod a socketet
};


window.vueio = io.connect(`${window.config.socket_host}:${window.config.socket_port}`, {
    ...SOCKET_OPTS,
    auth: {
        merkozesId: params.merkozesId,
        felulet: params.felulet,
        token: VueCookies.get('MKSZ-AUTH') || null, // ha kell cookie/token
    },
    query: {merkozesId: params.merkozesId, felulet: params.felulet}});
//window.vueio = io.connect(`${window.config.socket_host}:${window.config.socket_port}`);
//Vue.prototype.socketio = io.connect(`${window.config.socket_host}:${window.config.socket_port}`);
//export const eventBus = new Vue();

window.vueio.on('connect', function () {
    if (localStorage.getItem('socket_disconnect')) {
        let sdata = JSON.parse(localStorage.getItem('socket_disconnect'));
        Bugsnag.notify("Report screen discconnected =>" + sdata.reason, function (ev) {
            ev.severity = 'warning';
            ev.context = 'User disconnected from socket on reportscreen: ' + sdata.time;
        });
        localStorage.removeItem('socket_disconnect');
    }

    eventBus.$emit(CONSTANTS.EVENTS.CHANGE.CONNECTION, 'ok');
    Bugsnag.notify("Report screen connected", function (ev) {
        ev.severity = 'warning';
        ev.context = 'User connected to socket on reportscreen';
    });
});

window.vueio.on("disconnect", (reason) => {
    console.log("Kapcsolat megszakadt:", reason);
    eventBus.$emit(CONSTANTS.EVENTS.CHANGE.CONNECTION, 'error');
    localStorage.setItem('socket_disconnect', JSON.stringify({reason: reason, time: new Date()}));
});

//window.dbmanager = require('./dbmanager');
window.dbmanager = dbmanager;
window.appversion = window.version.appVersion;
window.dbname = "mksz";
window.vuexStore = store;
window.period = '1';

Vue.prototype.eventBus = eventBus;
window.dbmanager.eventBus = eventBus;
window.logoutWithoutClean = function () {
    if (window.vueApp && window.vueApp.$cookies) {
        window.vueApp.$cookies.remove('MKSZ-AUTH');
        window.vueApp.$cookies.remove('MKSZ-MATCHID');
    }
    // router.replace('logout');
    // ez az emit fog dobni logout eventet, ami átirányít
    window.vueio.emit("logout", window.username);
}
window.dmrForceLogout = function () {
    if (!document.location.href.includes("localhost")) {
        Bugsnag.notify("dmrForceLogout", function (ev) {
            ev.severity = 'info';
            ev.context = 'Logout';
            let cookies = {};
            let helper = document.cookie.split("; ");
            for (const key in helper) {
                let tmp = helper[key].split("=");
                cookies[tmp[0]] = tmp[1];
            }

            ev.addMetadata('cookie_data', cookies);
        });
    }
    //this.$cookies.remove('MKSZ-AUTH');
    router.replace('game-not-started');
}
window.forceClean = function () {
    debug("force clean");
    if (window.vueApp && window.vueApp.$cookies) {
        window.vueApp.$cookies.remove('MKSZ-AUTH');
        window.vueApp.$cookies.remove('MKSZ-MATCHID');
    }
    window.onbeforeunload = null;
    // JAVÍTÁS (ADATVESZTÉS): itt korábban egy FELTÉTEL NÉLKÜLI
    // `window.dbmanager.clear()` állt, ami a meccs teljes helyi tárolóját
    // kiürítette - beleértve a MÉG FEL NEM SZINKRONIZÁLT eseményeket is -,
    // és csak EZUTÁN futott a `cleanIfSynced()`, aminek pont az lett volna a
    // dolga, hogy CSAK akkor töröljön, ha már minden felment a szerverre. A
    // védelem tehát hatástalan volt: mire megvizsgálta volna, hogy van-e
    // szinkronizálatlan adat, azt a `clear()` már megsemmisítette.
    // Ez nem elméleti kockázat: a szerver MINDEN leállításkor/újraindításkor
    // `logout`-ot küld az ÖSSZES csatlakozott kliensnek
    // (digital-report-socket/server.js gracefulShutdown), a kliens pedig erre
    // ezt a függvényt hívja - vagyis minden egyes deploy/pod-újraindítás
    // kitörölte minden éppen dolgozó felhasználó még fel nem küldött
    // eseményeit. Mostantól KIZÁRÓLAG a `cleanIfSynced()` törölhet, ami
    // előbb ellenőrzi, hogy tényleg minden szinkronban van-e; ha nincs, a
    // helyi adat ÉRINTETLEN marad, és a következő sikeres kapcsolódáskor a
    // normál szinkron-mechanizmus fel tudja küldeni.
    window.dbmanager.cleanIfSynced().then(() => {
        router.replace('logout').catch(() => {
        });
    }, () => {
        // Van még fel nem küldött esemény - NEM törlünk és NEM navigálunk el,
        // hogy az adat megmaradjon és a szinkron később befejeződhessen.
        debug("YOU ARE NOT SYNCED - a helyi adatot megtartjuk");
        Bugsnag.notify("forceClean skipped: unsynced data kept", function (event) {
            event.severity = 'warning';
            event.context = 'forceClean - unsynced local data preserved';
            event.addMetadata('force_clean', {
                usertype: window.usertype,
                merkozesId: window.dbname
            });
        });
    });
};

let ts_socket = io(`${window.config.timesync_host}:${window.config.timesync_port}`, {
    ...SOCKET_OPTS
});
let ts = window.timesync.create({
    server: ts_socket,
    interval: 5000
});

ts.send = function (socket, data, timeout) {
    if(socket) {
        return new Promise(function (resolve, reject) {
            let timeoutFn = setTimeout(reject, timeout);
            socket.emit('timesync', data, function () {
                clearTimeout(timeoutFn);
                resolve();
            });
        });
    }
};

ts_socket.on('timesync', function (data) {
    ts.receive(null, data);
});
ts_socket.on('disconnect', function () {
    Bugsnag.notify("TimeSync disconnect", function (ev) {
        ev.severity = 'warning';
        ev.context = 'User Disconnected from timeSync';
    });
    debug("user disconnected");
});

window.ts = ts;

// reload dialog
window.onbeforeunload = function () {
    return "";
};

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueHotkey);
Vue.use(VueCookies);

window.purge = function () {
    window.vueio.emit("purge");
    window.forceClean();
};

// @TODO logout és no permission esetén ezt nem kéne!!!
router.replace('login');

// Globális szűrő
Vue.filter('reverse', function (value) {
    return value.slice().reverse();
});

Vue.use(NetworkPlugin);

const app = new Vue({
    router,
    vuetify,
    render: h => h(App),
    store
}).$mount('#app');
window.vueApp = app;
